import ParamsEditor from './shared/ParamsEditor';

interface ImgixParams {
  [key: string]: any;
}

interface ImageParamsEditorProps {
  defaultParams: any;
  originalCode: string;
  onParamsChange: (params: any, editorContent?: string) => void;
  currentImageSetId?: string | null;
}

function ImageParamsEditor({ defaultParams, originalCode, onParamsChange, currentImageSetId }: ImageParamsEditorProps) {
  return (
    <ParamsEditor
      title="Product Parameters"
      titleKey="product_parameters"
      defaultParams={defaultParams}
      originalCode={originalCode}
      onParamsChange={onParamsChange}
      currentImageSetId={currentImageSetId}
      storageKeyPrefix="productEditorContent_"
    />
  );
}

export default ImageParamsEditor;